// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-0EF","rootNoMargin":"styles_rootNoMargin__2i7xV"};